<div (dvaClickOutside)="onClickOutside()" class="toolbar-notifications" fxFlex="grow" fxLayout="row"
  fxLayoutAlign="start center">
  <button (click)="toggleDropdown()" [class.open]="isOpen" class="button" fxFlex="grow" mat-button type="button">
    <mat-icon [matBadgeHidden]="notifications.length === 0" [matBadge]="notifications.length" class="icon">
      notifications_active
    </mat-icon>
  </button>

  <div [class.open]="isOpen" class="dropdown">
    <dva-card>
      <dva-card-header class="dropdown-header">
        <dva-card-header-heading>
          Notifications
        </dva-card-header-heading>
        <dva-card-header-subheading>
          You have {{ notifications.length }} new notifications.
        </dva-card-header-subheading>

        <dva-card-header-actions>
          <button mat-icon-button type="button">
            <mat-icon class="icon">settings</mat-icon>
          </button>
        </dva-card-header-actions>
      </dva-card-header>

      <dva-card-content class="dropdown-card-content">
        <dva-scrollbar class="dropdown-content">
          <div fxLayout="column">
            <ng-container *ngFor="let notification of notifications; let last = last">
              <div (click)="markAsRead(notification)" [@listFade] [class.read]="notification.read"
                [ngClass]="notification.colorClass" class="notification" fxLayout="row" fxLayoutAlign="start center"
                matRipple>
                <mat-icon class="icon">{{ notification.icon }}</mat-icon>
                <div class="label" fxLayout="column">
                  <div class="name">{{ notification.name }}</div>
                  <div class="time">{{ notification.time }}</div>
                </div>
                <span fxFlex></span>
                <button (click)="dismiss(notification, $event)" mat-icon-button type="button">
                  <mat-icon class="close">close</mat-icon>
                </button>
              </div>
              <mat-divider *ngIf="!last"></mat-divider>
            </ng-container>
          </div>
          <div *ngIf="notifications.length === 0" [@listFade] class="empty">
            All fine! No notifications right now.
          </div>
        </dva-scrollbar>
      </dva-card-content>

      <dva-card-actions (click)="markAllAsRead()" class="dropdown-footer" matRipple>
        Mark all as read
      </dva-card-actions>
    </dva-card>
  </div>
</div>